/**
 * This component will be used to show coming soon product and bookmarked them by clicking over icon.
 *
 * @module views/components/ProductComingSoon
 * @memberof -Common
 */
import './ProductComingSoon.scss';

import React from 'react';

import PropTypes from 'prop-types';

import AsyncComponent from '@ulta/core/components/AsyncComponent/AsyncComponent';
import Text from '@ulta/core/components/Text/Text';

import Tag from '@ulta/modules/Tag/Tag';

/**
 * Represents a ProductComingSoon component
 *
 * @method
 * @param {ProductComingSoonProps} props - React properties passed from composition
 * @returns ProductComingSoon
 */
export const ProductComingSoon = function( props ){
  return (
    <div className='ProductComingSoon'>
      <div className='ProductComingSoon__leftColumn'>
        <Tag
          variant='utility'
          style='notification'
          message={ props.comingSoonLabel }
        />
        <div className='ProductComingSoon__leftColumn__info'>
          <Text
            textStyle='body-3'
          >
            { props.comingSoonMessage }
          </Text>
        </div>
      </div>
      <div className='ProductComingSoon__rightColumn'>
        <AsyncComponent
          id={ props.id }
          bookmarkAction={ props.bookmarkAction }
          bookmarked={ props.bookmarked }
          commerceId={ props.commerceId }
          key='ProductBookmark'
          moduleName='ProductBookmark'
          productActionsProps={ props }
          productId={ props.productId }
          quantity={ props.quantity }
          removeBookmarkAction={ props.removeBookmarkAction }
          skuId={ props.skuId }
          state={ props.state }
        />
      </div>
    </div>
  );
};

/**
 * Property type definitions
 *
 * @typedef ProductComingSoonProps
 * @type {object}
 * @property {string} comingSoonLabel - Sets the label for the coming soon
 * @property {string} comingSoonMessage - Sets the comingSoonMessage property
 * @property {boolean} bookmarked - Flag to render heart icon's state
 * @property {object} removeBookmarkAction - Sets the removeBookmarkAction properties
 * @property {object} bookmarkAction - Sets the bookmarkAction properties
 */
export const propTypes =  {
  comingSoonLabel: PropTypes.string.isRequired,
  comingSoonMessage: PropTypes.string.isRequired,
  bookmarked: PropTypes.bool,
  bookmarkAccessibility: PropTypes.string,
  bookmarkAction: PropTypes.shape( {
    label: PropTypes.string,
    graphql: PropTypes.string
  } ),
  removeBookmarkAction: PropTypes.shape( {
    label: PropTypes.string,
    graphql: PropTypes.string
  } )
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} bookmarked=false - Flag to specify if the bookmark is filled or not, default is false
 */
export const defaultProps = {
  bookmarked: false
};

ProductComingSoon.propTypes = propTypes;
ProductComingSoon.defaultProps = defaultProps;

export default ProductComingSoon;
